import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Global loading indicator service.
 *
 * Exposes a single `BehaviorSubject<boolean>` consumed by `AppComponent`
 * to render a full-screen overlay. Use `show(true)` / `show(false)` from
 * feature services or components whenever an HTTP request is in flight.
 *
 * The interceptor-based design lives in `error.interceptor.ts` and
 * automatically toggles the flag on completion, so most call-sites do not
 * need to invoke this directly.
 */
@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private readonly _loading = new BehaviorSubject<boolean>(false);
  readonly loading$: Observable<boolean> = this._loading.asObservable();

  /** Synchronous accessor. */
  get isLoading(): boolean {
    return this._loading.value;
  }

  show(flag: boolean): void {
    if (this._loading.value !== flag) {
      this._loading.next(flag);
    }
  }
}
